function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "b"
}, React.createElement("rect", {
  width: 48,
  height: 48
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "a",
  clipPath: "url(#b)"
}, React.createElement("path", {
  d: "M31.474,29H56.839a2.474,2.474,0,0,1,1.749.725l4.324,4.324h0a2.474,2.474,0,0,1,.725,1.749V61.163a2.474,2.474,0,0,1-2.474,2.474H31.474A2.474,2.474,0,0,1,29,61.163V31.474h0A2.474,2.474,0,0,1,31.474,29Zm4.948,2.474H32.3a.825.825,0,0,0-.825.825V60.338a.825.825,0,0,0,.825.825H60.338a.825.825,0,0,0,.825-.825v-24.2h0a.825.825,0,0,0-.242-.583l-3.84-3.84h0a.825.825,0,0,0-.583-.242h-.383a.725.725,0,0,0-.725.725v5.873a2.474,2.474,0,0,1-2.474,2.474H39.721a2.474,2.474,0,0,1-2.474-2.474V32.3a.825.825,0,0,0-.825-.825Zm4.123,6.6H52.091a.825.825,0,0,0,.825-.825V32.3a.825.825,0,0,0-.825-.825H40.546a.825.825,0,0,0-.825.825v4.948A.825.825,0,0,0,40.546,38.072Zm-4.123,7.422H56.215a2.474,2.474,0,0,1,2.474,2.474v8.247a2.474,2.474,0,0,1-2.474,2.474H36.422a2.474,2.474,0,0,1-2.474-2.474V47.968A2.474,2.474,0,0,1,36.422,45.494Zm0,3.3v6.6a.825.825,0,0,0,.825.825H55.39a.825.825,0,0,0,.825-.825v-6.6a.825.825,0,0,0-.825-.825H37.247A.825.825,0,0,0,36.422,48.792Z",
  transform: "translate(-22 -22)"
}));

var SvgDisquette = function SvgDisquette(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDisquette, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Disquette.657bc803.svg";
export { ForwardRef as ReactComponent };